exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rounded-corner[data-v-9c797a08]{border-start-end-radius:20px;border-end-start-radius:20px}", ""]);

// exports
